var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEyeClosedinline = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.127494 6.51139663.4886034-.87250601 1.745012.97720673-.4886034.87250602c-2.0297628 3.62457643-4.6713111 5.51139663-7.872506 5.51139663-3.20119495 0-5.8427432-1.8868202-7.87250602-5.51139663l-.48860337-.87250602 1.74501204-.97720673.48860337.87250601c1.70357052 3.04209022 3.72868893 4.48860337 6.12749398 4.48860337 2.3988051 0 4.4239235-1.44651315 6.127494-4.48860337z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.82233263 5.67742927-1.39040939-1.43762364c1.53713314-1.48665083 3.41091763-2.23980563 5.56807676-2.23980563 2.241405 0 4.1754476.81305458 5.7440576 2.41470963l-1.4288769 1.39939661c-1.1924351-1.21755553-2.61147205-1.81410624-4.3151807-1.81410624-1.63983513 0-3.01463202.55259017-4.17766737 1.67742927z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 12h2v3h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.5527864 9.65835921 1.78885439.89442719-1.89442719 3.7888544-1.78885439-.8944272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.6583592 10.5527864 1.7888544-.89442719 1.8944272 3.78885439-1.7888544.8944272z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEyeClosedinline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/eye-closed.inline.29b744bdca6584d51790431605f1f2f2.svg";